import { FormikErrors, FormikContextType } from 'formik';

export type FormValidationErrorLine = `${string}: ${string}`;

export type FormValidationPayload = {
	formPath: string;
	errors: FormValidationErrorLine[];
};

function collectFormErrorsFromValue(value: string, key: string): { field: string; message: string } {
	return { field: key, message: value };
}

function collectFormErrors(errors: FormikErrors<unknown>): { field: string; message: string }[] {
	return Object.keys(errors).flatMap((key) => {
		const value = errors[key as keyof FormikErrors<unknown>];
		if (typeof value !== 'string') {
			return [];
		}

		return collectFormErrorsFromValue(value, key);
	});
}

export function trackFormErrors<T extends FormikContextType<unknown>>(
	formPath?: string,
): (errors: FormikErrors<T>) => FormValidationPayload {
	return (errors: FormikErrors<T>) => {
		const payload: FormValidationPayload = {
			formPath: formPath ?? '',
			errors: collectFormErrors(errors).map((error): FormValidationErrorLine => `${error.field}: ${error.message}`),
		};

		return payload;
	};
}
